import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 50844 43528"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:563.442}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315463888">
        <path
          d="M47686 2174H3159c-192 0-349-156-349-349s156-349 349-349h44527c193 0 349 156 349 349s-156 349-349 349z"
          className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M1826 980c-466 0-846 379-846 845s380 845 846 845 845-379 845-845-380-845-845-845zm0 2388c-851 0-1544-692-1544-1543S975 282 1826 282s1543 692 1543 1543c1 851-692 1543-1543 1543zM49019 980c-465 0-845 379-845 845s380 845 845 845c466 0 846-379 846-845s-380-845-846-845zm0 2388c-851 0-1543-692-1543-1543s692-1543 1543-1543 1544 692 1544 1543-693 1543-1544 1543zM44518 42856h-453c-683 0-1340-289-1803-792s-695-1183-638-1864l443-5247c17-192 186-335 377-318 192 16 335 185 318 377l-442 5247c-42 494 120 967 456 1332 279 304 643 494 1043 550V1920c0-193 157-349 349-349 193 0 349 156 349 349l1 40936z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M41780 40426c-683 0-1341-288-1804-791-463-504-695-1183-637-1864l442-5247c17-193 184-335 377-319 192 17 336 186 319 378l-442 5246c-42 495 120 967 455 1333 337 365 794 566 1290 566 193 0 349 157 349 349 1 193-156 349-349 349z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M39494 38161c-683 0-1340-289-1803-793-463-502-695-1182-638-1863l443-5247c17-192 183-335 377-319 192 17 335 186 318 378l-442 5246c-42 494 120 968 456 1334 336 364 794 565 1289 565 193 0 349 157 349 350 1 192-156 349-349 349z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M37209 35895h-40c-675 0-1327-283-1789-777-461-493-701-1162-655-1836l485-7252c13-192 180-338 371-325 193 13 338 179 326 372l-486 7251c-32 489 134 955 469 1313 334 358 789 556 1279 556h40c193 0 349 156 349 349 0 192-156 349-349 349z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M34825 26627c-442 0-862-262-1046-684-128-295-126-630 7-922 131-292 381-516 687-615 1835-592 6435-2177 9511-4090 164-101 379-51 481 113 102 163 52 378-112 481-3142 1954-7806 3561-9666 4161-119 38-213 123-265 237-51 115-53 241-2 357 87 199 309 307 519 248 3311-918 9031-3432 9089-3457 176-78 382 2 460 179 78 176-3 382-179 459-57 26-5824 2560-9183 3493-100 26-201 40-301 40z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M36139 24563c-52 0-104-11-153-35-133-65-3296-1624-6447-5198-1850-2099-3306-4458-4326-7011-1275-3190-1869-6692-1767-10408 5-193 165-345 358-340s345 166 340 359c-226 8195 3094 13734 5919 16938 3059 3470 6197 5016 6228 5032 174 84 246 293 161 466-60 125-184 197-313 197zM41780 18307c-193 0-349-157-349-350V7332c0-193 156-349 349-349s349 156 349 349l1 10625c0 193-157 350-350 350z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M7317 43246c-427 0-855-103-1247-310l-1437-758V1920c0-193 156-349 348-349 193 0 350 156 350 349v39836l1065 562c591 312 1293 305 1877-19l1403-777 1418 749c592 311 1293 304 1877-19l1404-777 1418 748c591 312 1293 305 1877-19l1403-777 1419 749c591 311 1293 304 1877-19l1059-586V1920c0-193 156-349 349-349s350 156 350 349v40063l-1419 785c-791 437-1742 447-2542 26l-1084-573-1073 594c-791 438-1742 448-2542 27l-1084-573-1073 594c-792 438-1742 447-2541 26l-1085-572-1073 593c-403 224-849 336-1294 336z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
        <path
          d="M9680 42269c-193 0-349-156-349-349v-9367c0-192 156-349 349-349 193-1 349 157 349 349l1 9367c0 193-157 349-350 349zM14379 42221c-193 0-350-156-350-349l1-16721c0-193 156-349 349-349s349 156 349 349v16720c0 194-156 350-349 350zM19077 42173c-192 0-349-156-349-349V16997c0-193 157-349 349-349 194 0 349 156 349 349v24827c0 193-156 349-349 349z"
                    className="fill stroke1"
          style={{
            strokeWidth: 563.442,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
